"use client";
import axiosInstance from "../config";
import { decryptObject, encryptObject, generateNonce } from "@/helpers/noncehelper";
const axios: any = axiosInstance();
export const addFavourites = async (
  encryptedPayload: any
) => {
  try {
    const { token } = decryptObject(encryptedPayload) as any;
    const response = await axios.post("/recipes/favorites", encryptedPayload, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${encryptObject({encrypt: crypto.randomUUID()}).toUpperCase()}`,
        "focus": `${token}`,
        "x-nonce-token": generateNonce(),
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error:", error);
  }
};

export const fetchFavourites = async (payload: any) => {
  try {
    const { token } = decryptObject(payload) as any;
    const response = await axios.get("/recipes/favorites", {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${encryptObject({encrypt: crypto.randomUUID()}).toUpperCase()}`,
        "focus": `${token}`,
        "x-nonce-token": generateNonce(),
      },
    });
    return response.data;
  } catch (error) {
    console.error("API call failed:", error);
    return error;
  }
};

export const removeFavourites = async (path: string, body: object) => {
  try {
    const response = await axios.delete(path, {
      data: body,
    });
    return response.data;
  } catch (error: any) {
    throw error.data?.error;
  }
};

export const fetchPreferencesFromSpoonguru = async (path: string) => {
  // return fetchFavourites(path);
};

export const setPreferencesToSpoonguru = async (path: string, body: object) => {
  // return addFavourites(path, body);
};
